import type { MarketConfig } from './instruments'

type MarketCardProps = {
  market: MarketConfig
}

/**
 * Single reusable market card — all content from MarketConfig.
 */
export function MarketCard({ market }: MarketCardProps) {
  return (
    <article className="wm-card">
      <div className="wm-card__top">
        <span className="wm-badge">Available</span>
        <span className="wm-live">
          <span className="wm-live__dot" aria-hidden="true" />
          {market.status}
        </span>
      </div>

      <h3 className="wm-card__name">{market.name}</h3>
      <p className="wm-card__symbol">{market.symbol}</p>
      <p className="wm-card__blurb">{market.description}</p>
    </article>
  )
}
